import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    PERFIL_ADMIN
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import selecionarAdesaoPonto from '../../actions/adesao-pontos/selecionarAdesaoPonto';

export class MenuAdesaoPontos extends Component {

    render() {
        return (
            <div className="area-home">
                <Titulo texto="Adesão de pontos" urlRetorno="/gestao" />
                <div className="row sistemas">
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-cadastro-configuracao-ponto"
                                onClick={() => this.props.selecionarAdesaoPonto(null)}>
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons">&#xe8b6;</i>
                                        <h5 className='nm-longo-resize'>
                                            Nova Configuração
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-gerenciar-adesao-pontos">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons">&#xe8b6;</i>
                                        <h5 className='nm-longo-resize'>
                                            Gestão de Pontos
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                </div>
            </div>
        )
    }
}


export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}


export default withRouter(connect(mapStateToProps, {
    selecionarAdesaoPonto
})(MenuAdesaoPontos));